module.exports = __webpack_public_path__ + "img/B_MarkLogo.6b01676a.svg";